import { IOfferSpendListTableLang } from '../../../types/lang'

export const offerSpendListTableLang: IOfferSpendListTableLang = {
	offer_spend_list_table: {
		column_id: 'ID_ua',
		column_date: 'Date_ua',
		column_date_updated: 'Date Updated_ua',
		column_amount: 'Amount_ua',
		column_account_id: 'Account ID_ua',
		column_account: 'Account_ua',
		column_account_in_group: 'Account in Group_ua',
		column_kt_group: 'KT Group_ua',
		column_offer_id: 'Offer ID_ua',
		column_offer: 'Offer_ua',
		column_scope_id: 'Scope ID_ua',
		column_scope: 'Scope_ua',
		column_history: 'History_ua',
		column_notes: 'Notes_ua'
	}
}